export const categories = [
  {
    id: 1,
    name: 'Hoteles en Chile',
    description: 'Alojamiento en los mejores hoteles de norte a sur.',
    image: 'https://images.unsplash.com/photo-1506744038136-46273834b3fb?w=400',
    productCount: 45
  },
  {
    id: 2,
    name: 'Servicios Turísticos',
    description: 'Traslados, guías, tours y experiencias para viajeros.',
    image: 'https://images.unsplash.com/photo-1503736334956-4c8f8e92946d?w=400',
    productCount: 32
  },
  {
    id: 3,
    name: 'All Inclusive',
    description: 'Paquetes todo incluido: hotel, comidas y actividades.',
    image: 'https://images.unsplash.com/photo-1500534314209-a25ddb2bd429?w=400',
    productCount: 28
  },
  {
    id: 4,
    name: 'Turismo de Nieve',
    description: 'Centros de ski, excursiones y actividades en la nieve.',
    image: 'https://images.unsplash.com/photo-1517841905240-472988babdf9?w=400',
    productCount: 67
  },
  {
    id: 5,
    name: 'Programas Santiago y Centro',
    description: 'Tours urbanos, viñas y escapadas en la zona central.',
    image: 'https://images.unsplash.com/photo-1502741338009-cac2772e18bc?w=400',
    productCount: 23
  },
  {
    id: 6,
    name: 'Multidestino Nacional',
    description: 'Viajes combinados por varios destinos de Chile.',
    image: 'https://images.unsplash.com/photo-1501785888041-af3ef285b470?w=400',
    productCount: 41
  }
];

export const products = [
  // Hoteles en Chile
  {
    id: 1,
    name: 'Hotel Patagonia 2025 - 2026',
    description: 'Habitaciones con vista a la montaña, desayuno buffet y spa.',
    price: 899.99,
    categoryId: 1,
    image: 'https://images.unsplash.com/photo-1500534314209-a25ddb2bd429?w=400',
    stock: 150,
    sku: 'HOTEL-001',
    lastUpdated: '2024-07-20',
    files: [
      { name: 'Ficha_Hotel.pdf', url: 'https://www.africau.edu/images/default/sample.pdf', type: 'pdf' },
      { name: 'Servicios_Hotel.docx', url: 'https://www.africau.edu/images/default/sample.docx', type: 'docx' },
      { name: 'Tarifas_2025.xlsx', url: 'https://www.africau.edu/images/default/sample.xlsx', type: 'xlsx' },
    ]
  },
  {
    id: 2,
    name: 'Hotel Sur Austral',
    description: 'Ubicado en la Patagonia, incluye excursiones y traslados.',
    price: 1299.99,
    categoryId: 1,
    image: 'https://images.unsplash.com/photo-1464983953574-0892a716854b?w=400',
    stock: 75,
    sku: 'HOTEL-002',
    lastUpdated: '2024-07-18',
    files: [
      { name: 'Ficha_Hotel.pdf', url: 'https://www.africau.edu/images/default/sample.pdf', type: 'pdf' },
      { name: 'Servicios_Hotel.docx', url: 'https://www.africau.edu/images/default/sample.docx', type: 'docx' },
    ]
  },
  {
    id: 3,
  name: 'Hoteles Santiago 2025 - 2026',
  description: 'Panoramas, actividades en Santiago de Chile',
    price: 199.99,
    categoryId: 1,
  image: 'https://images.unsplash.com/photo-1502086223501-7ea6ecd79368?w=400', // Santiago de Chile ciudad Unsplash
    stock: 200,
    sku: 'ELEC-003',
    lastUpdated: '2024-07-15',
    files: [
      { name: 'Manual_Auriculares.pdf', url: 'https://www.africau.edu/images/default/sample.pdf', type: 'pdf' },
    ]
  },
  // Servicios Chile
  {
    id: 4,
  name: 'Servicios Santiago',
  description: 'Servicios de movilidad y transporte en Santiago',
  price: 349.99,
  categoryId: 2,
  image: 'https://images.unsplash.com/photo-1502877338535-766e1452684a?w=400', // Bicicletas Unsplash
    stock: 90,
    sku: 'HOME-001',
    lastUpdated: '2024-07-21',
    files: [
      { name: 'Guia_Rapida_Aspiradora.pdf', url: 'https://www.africau.edu/images/default/sample.pdf', type: 'pdf' },
      { name: 'Mantenimiento.xlsx', url: 'https://www.africau.edu/images/default/sample.xlsx', type: 'xlsx' },
    ]
  },
  {
    id: 5,
  name: 'Servicios San Pedro de Atacama',
  description: 'Servicios turísticos en el desierto de Atacama',
  price: 89.99,
  categoryId: 2,
  image: 'https://images.unsplash.com/photo-1501785888041-af3ef285b470?w=400', // Desierto de Atacama Unsplash
    stock: 120,
    sku: 'HOME-002',
    lastUpdated: '2024-07-19',
    files: []
  },
  // Productos All Inclusive
  {
    id: 6,
    name: 'Paquete All Inclusive Caribe',
    description: '7 noches en resort 5*, comidas, bebidas, actividades y traslados incluidos.',
    price: 1899.99,
    categoryId: 3,
    image: 'https://images.unsplash.com/photo-1506744038136-46273834b3fb?w=400',
    stock: 20,
    sku: 'ALLINC-001',
    lastUpdated: '2024-07-17',
    files: [
      { name: 'Itinerario_Paquete.pdf', url: 'https://www.africau.edu/images/default/sample.pdf', type: 'pdf' },
      { name: 'Condiciones_Paquete.docx', url: 'https://www.africau.edu/images/default/sample.docx', type: 'docx' },
    ]
  },
  {
    id: 7,
    name: 'All Inclusive Patagonia',
    description: '5 noches en hotel, excursiones, comidas y traslados en la Patagonia.',
    price: 1599.99,
    categoryId: 3,
    image: 'https://images.unsplash.com/photo-1464983953574-0892a716854b?w=400',
    stock: 15,
    sku: 'ALLINC-002',
    lastUpdated: '2024-07-22',
    files: [
      { name: 'Programa_Patagonia.pdf', url: 'https://www.africau.edu/images/default/sample.pdf', type: 'pdf' },
    ]
  },
  // Turismo de Nieve
  {
    id: 8,
    name: 'Ski Week Valle Nevado',
    description: '7 días de ski, alojamiento, clases y equipo incluido en Valle Nevado.',
    price: 1290.00,
    categoryId: 4,
    image: 'https://images.unsplash.com/photo-1517841905240-472988babdf9?w=400',
    stock: 30,
    sku: 'NIEVE-001',
    lastUpdated: '2024-07-16',
    files: [
      { name: 'Programa_SkiWeek.pdf', url: 'https://www.africau.edu/images/default/sample.pdf', type: 'pdf' }
    ]
  },
  {
    id: 9,
    name: 'Excursión Full Day Farellones',
    description: 'Transporte, ticket, equipo y actividades en la nieve para toda la familia.',
    price: 199.00,
    categoryId: 4,
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400',
    stock: 50,
    sku: 'NIEVE-002',
    lastUpdated: '2024-07-20',
    files: []
  },
  // Programas Santiago y Centro
  {
    id: 10,
    name: 'Tour Viñas y Sabores',
    description: 'Recorrido por viñedos, degustación de vinos y almuerzo en la zona central.',
    price: 120.00,
    categoryId: 5,
    image: 'https://images.unsplash.com/photo-1502741338009-cac2772e18bc?w=400',
    stock: 40,
    sku: 'STGO-001',
    lastUpdated: '2024-07-21',
    files: []
  },
  {
    id: 11,
    name: 'City Tour Santiago',
    description: 'Tour guiado por los principales atractivos de Santiago, incluye entradas.',
    price: 80.00,
    categoryId: 5,
    image: 'https://images.unsplash.com/photo-1502086223501-7ea6ecd79368?w=400',
    stock: 60,
    sku: 'STGO-002',
    lastUpdated: '2024-07-22',
    files: []
  },
  // Multidestino Nacional
  {
    id: 12,
    name: 'Ruta Lagos y Volcanes',
    description: 'Programa combinado: Puerto Varas, Pucón y Villarrica con excursiones.',
    price: 950.00,
    categoryId: 6,
    image: 'https://images.unsplash.com/photo-1501785888041-af3ef285b470?w=400',
    stock: 25,
    sku: 'MULTI-001',
    lastUpdated: '2024-07-23',
    files: []
  },
  {
    id: 13,
    name: 'Desierto y Altiplano',
    description: 'San Pedro de Atacama, excursiones a lagunas, salares y geisers.',
    price: 1100.00,
    categoryId: 6,
    image: 'https://images.unsplash.com/photo-1501785888041-af3ef285b470?w=400',
    stock: 20,
    sku: 'MULTI-002',
    lastUpdated: '2024-07-23',
    files: []
  }
];